export default __webpack_public_path__ + "static/media/julianelimamancini.5cfac008.jpg";